<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Hệ đào tạo
        </label>
        <b-form-select v-model="entry.type" :options="options"></b-form-select>
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            type: "",
        },
        options: [
          { value: null, text: 'Chọn hệ đào tạo...' },
          { value: 'Hệ đại học', text: 'Hệ đại học' },
          { value: 'Hệ cao học', text: 'Hệ cao học' },
          { value: 'Liên thông đại học', text: 'Liên thông đại học' },
          { value: 'Khóa học ngắn hạn', text: 'Khóa học ngắn hạn' },
        ]
    }),
    watch: {
        "entry.type": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    type: this.entry.type,
                });
            },
            deep: true,
        },
        "value.type": {
            handler: function () {
                this.entry.type = this.value.type;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>